// The site's own visit counter (backend/visits.py; counts at /api/visits):
// one event per tab visit and one per storm opened. No cookies; nothing
// personal. Production builds only, so local dev and previews send nothing.
import { apiUrl } from "./data/liveApi";
import { deviceClass, visitInfo } from "./engine/visit";
import { useStore } from "./state/store";

function send(kind: "visit" | "storm", data: object): void {
  const body = JSON.stringify({ k: kind, ...data });
  const url = apiUrl("/api/visit");
  try {
    // text/plain keeps it a simple cross-origin request (no preflight)
    if (navigator.sendBeacon?.(url, new Blob([body], { type: "text/plain" }))) return;
  } catch {
    // fall through to fetch
  }
  void fetch(url, { method: "POST", body, keepalive: true, mode: "no-cors", headers: { "Content-Type": "text/plain" } })
    .catch(() => {});
}

/** True the first time `key` is seen in this tab (a reload is not a new visit). */
function firstInTab(key: string): boolean {
  try {
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, "1");
  } catch {
    // storage blocked: count it anyway
  }
  return true;
}

export function startAnalytics(): void {
  if (!import.meta.env.PROD) return;
  const device = deviceClass(matchMedia("(pointer: coarse)").matches, Math.min(screen.width, screen.height));
  if (firstInTab("sce-visit")) send("visit", visitInfo(document.referrer, location.search, location.hash, device));
  useStore.subscribe((st, prev) => {
    const id = st.live.selectedId;
    if (id && id !== prev.live.selectedId && firstInTab(`sce-storm-${id}`)) send("storm", { s: id, d: device });
  });
}
